module.exports = __webpack_public_path__ + "img/corner-file-table.8e24a956.svg";